import { NgModule } from '@angular/core';
import { MobileValidatorDirective } from './mobile-validator.directive';
import { NationalCodeValidatorDirective } from './national-code-validator.directive';
import { PhoneValidatorDirective } from './phone-validator.directive';
import { WebsiteValidatorDirective } from './website-validator.directive';
import { equalWithValidator } from './equal-with/equalWith-validator';
import { EqualWithDirective } from './equal-with/equalWith.directive';

@NgModule({
  declarations: [
    MobileValidatorDirective,
    NationalCodeValidatorDirective,
    PhoneValidatorDirective,
    WebsiteValidatorDirective,
    EqualWithDirective
  ],
  imports: [
  ],
  exports: [
    MobileValidatorDirective,
    NationalCodeValidatorDirective,
    PhoneValidatorDirective,
    WebsiteValidatorDirective,
    EqualWithDirective
  ]
})
export class ValidationModule { }
